import HttpService from "./HttpService";
const API_URL = "/recruitment-experience";

const ExperienceService = {
  fetch: async () => {
    try {
      const response = await HttpService.get(`${API_URL}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching experiences:", error);
      throw error;
    }
  },
  fetchPaginated: async (pageConfig) => {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_URL}-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching experiences:", error);
      throw error;
    }
  },

  add: async (data) => {
    try {
      const response = await HttpService.post(API_URL, data);
      return response.data;
    } catch (error) {
      console.error("Error adding experience:", error);
      throw error;
    }
  },

  edit: async (id) => {
    try {
      const response = await HttpService.get(`${API_URL}/${id}/edit`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, updatedData) => {
    // data["_method"] = "PUT";
    try {
      const response = await HttpService.put(`${API_URL}/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating experience:", error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await HttpService.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting experience:", error);
      throw error;
    }
  },
};

export default ExperienceService;
